import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, createClass as _createClass } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { __rest } from '../../_virtual/_tslib.js';
import { VideoWrapper } from '@lsg/shared';
import { createElement, Component } from 'react';

var Video = /*#__PURE__*/function (_Component) {
  _inherits(Video, _Component);
  var _super = _createSuper(Video);
  function Video() {
    _classCallCheck(this, Video);
    return _super.apply(this, arguments);
  }
  _createClass(Video, [{
    key: "render",
    value: function render() {
      var _a = this.props,
        left = _a.left,
        right = _a.right,
        props = __rest(_a, ["left", "right"]);
      return /*#__PURE__*/createElement(VideoWrapper, Object.assign({}, props, {
        actionTopLeft: left,
        actionTopRight: right
      }));
    }
  }]);
  return Video;
}(Component);
Video.displayName = "Video";

export { Video };
